import clsx from 'clsx';
import { useState } from 'react';

import { TaskSampling } from '@/api/spirit/api';
import { ReactComponent as DownArrowIcon } from '@/assets/icons/bx-chevron-down.svg';
import SamplingIcon from '@/assets/icons/requiment_sampleng.svg';

export const Sampling = (props: { task: TaskSampling }) => {
  const [isToggle, setToggle] = useState<boolean>(false);
  const { task } = props;

  return (
    <div className="flex justify-center gap-3">
      <div className="flex flex-col items-center text-sm">
        <div className="flex aspect-square w-10 items-center justify-center rounded-full bg-white">
          <img src={SamplingIcon} alt="" className="w-5" />
        </div>
        <div className={clsx('w-[2px] bg-gray-300', isToggle ? 'h-full' : 'h-[50px]')} />
      </div>
      <div className="w-[190px]">
        <h5 className="mb-1 font-semibold leading-5 ">サンプリング</h5>
        <p className="mb-2 text-sm font-semibold text-gray-400">{task.title}</p>
        {isToggle && (
          <div className="mb-2 w-[190px] rounded-lg bg-gray-100">
            <div className="mb-2 gap-2">
              <p className="text-sm font-semibold">商品概要</p>
              <p className="text-xs">{task.summaryText}</p>
            </div>
          </div>
        )}
        <button
          onClick={() => setToggle((value: boolean) => !value)}
          className="mx-auto my-0 mb-2 flex w-[190px] text-blue-500 underline focus:outline-none"
        >
          <span className="inline-block items-center text-xs">{isToggle ? '最小に戻す' : 'もっと見る'}</span>
          <DownArrowIcon
            height={16}
            width={16}
            fill="#3b82f6"
            className={`text-blue-500 transition-transform duration-300 ${isToggle ? 'rotate-180' : ''}`}
          />
        </button>
      </div>
    </div>
  );
};
